import React from "react";
import { Container, Segment } from "semantic-ui-react";

import AppHeader from "./AppHeader";
import Uploader from "./Uploader";
import Display from "./Display";

class App extends React.Component {
	state = {
		photo: null,
	};

	setPhoto = (photo) => {
		this.setState({
			photo: {
				src: URL.createObjectURL(photo),
				name: photo.name,
				size: photo.size,
			},
		});
	};

	render() {
		return (
			<div>
				<AppHeader />
				<Container>
					<Uploader
						onPhoto={(photo) => {
							this.setPhoto(photo);
						}}
					/>
					<Display photo={this.state.photo} />
					<div style={{ height: "20px" }} />
				</Container>
			</div>
		);
	}
}

export default App;
